// CDP-screencast WS client helper.
//
// Pairs with `app/routes/screencast.py` on takeover-api. Opens a
// WebSocket to the screencast bridge for a session, returns the
// bare `WebSocket` instance for the caller (StepCaptchaScreencast)
// to wire up message + close handlers.
//
// Auth: the session token rides in the Sec-WebSocket-Protocol header,
// `new WebSocket(url, ['vantage.bearer', token])`: the one header a
// browser WebSocket can set. It is never put in the URL, because a query
// string is recorded by load-balancer access logs, browser history and
// Referer. The server echoes 'vantage.bearer' (takeover-api app/ws_auth.py).
//
// URL transform: `REACT_APP_TAKEOVER_API_URL` is `http(s)://...`;
// we swap the scheme to `ws(s)://` and append the WS path. The
// staging deploy uses HTTPS → WSS; local dev uses HTTP → WS.

const API_URL = process.env.REACT_APP_TAKEOVER_API_URL || 'http://localhost:8000';

export const WS_AUTH_SUBPROTOCOL = 'vantage.bearer';

function toWsUrl(httpUrl) {
  return httpUrl.replace(/^http/i, 'ws');
}

export function connectScreencast(sessionId, sessionToken) {
  if (!sessionId) throw new Error('connectScreencast: sessionId required');
  if (!sessionToken) throw new Error('connectScreencast: sessionToken required');
  const wsBase = toWsUrl(API_URL);
  const url = `${wsBase}/api/takeover/viewer/screencast/${encodeURIComponent(sessionId)}`;
  return new WebSocket(url, [WS_AUTH_SUBPROTOCOL, sessionToken]);
}

// Close codes the BE may send. Surfaced as named constants so the
// component's onclose handler can render the right user-facing
// message instead of a numeric code.
export const SCREENCAST_CLOSE = {
  UNAUTHORIZED: 4001,
  NO_PUBLISHER: 4040,
  DISABLED: 4045,
};
